import React, { useState } from "react";
import { formMaker } from "../../util";
import {
  stringLiterals,
  userProfileFormSchema as formSchema,
  userProfileFormValidation as isValid,
} from "../../data";
import { Button, ButtonGroup, Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useUpdateUserInfoMutation } from "../../state/services/users";

// Render a form for a user to edit their user information.
function UserProfileEditor(props) {
  const { setShowEditor } = props;
  const userInfo = useSelector((state) => state.auth.userInfo);
  const [formData, setFormData] = useState(userInfo);
  const [formErrors, setFormErrors] = useState({});

  const [updateUserInfo] = useUpdateUserInfoMutation();

  const handleSubmit = async (event) => {
    event.preventDefault();

    const errors = {};
    for (const key in formData) {
      errors[key] = !isValid(key, formData[key]);
    }
    setFormErrors(errors);
    if (Object.values(errors).includes(true)) {
      return;
    }

    try {
      await updateUserInfo({ userId: userInfo._id, userInfo: formData });
      setShowEditor(false);
    } catch (err) {
      setShowEditor(false);
    }
  };

  return (
    <div className="section container text-left">
      <Form onSubmit={handleSubmit}>
        <h3>{`Update ${stringLiterals.userProfileTitle}`}</h3>
        <p className="text-right">
          <span> * Required</span>
        </p>

        {formMaker(
          formSchema,
          isValid,
          formData,
          setFormData,
          formErrors,
          setFormErrors
        )}

        <div className="text-center">
          <ButtonGroup>
            <Button
              className={"section-button"}
              variant="outline-danger"
              onClick={() => setShowEditor(false)}
            >
              Cancel
            </Button>
            <Button
              className={"section-button"}
              type="button"
              disabled={Object.values(formErrors).includes(true)}
              onClick={handleSubmit}
            >
              Confirm Changes
            </Button>
          </ButtonGroup>
        </div>
      </Form>
    </div>
  );
}

export default UserProfileEditor;
